import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "core/store";

const reducer = (state: RootState) => state.private.sign;

export const signTablePageSelector = createSelector(
	reducer,
	(state) => state.page
);

export const signTablePageSizeSelector = createSelector(
	reducer,
	(state) => state.pageSize
);

export const signTableSortSelector = createSelector(
	reducer,
	(state) => state.orderBy
);

export const signTableSortDirSelector = createSelector(
	reducer,
	(state) => state.orderByDir
);

export const signFiltersSelector = createSelector(
	reducer,
	(state) => state.filters
);

export const signListSelector = createSelector(
	reducer,
	(state) => state.listResponse
);
